import { SignInPage } from '@backstage/core-components';
import {
  configApiRef,
  microsoftAuthApiRef,
  SignInPageProps,
  useApi,
} from '@backstage/core-plugin-api';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

export function MicrosoftSignInPage(props: SignInPageProps) {
  const config = useApi(configApiRef);
  const microsoft = {
    id: 'microsoft-auth-provider',
    title: 'Microsoft',
    message: 'Sign in with your company Microsoft account',
    apiRef: microsoftAuthApiRef,
  };
  return (
    <SignInPage
      {...props}
      providers={
        config.getOptionalBoolean('auth.guest.enabled') === true
          ? [microsoft, 'guest']
          : [microsoft]
      }
    />
  );
}

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: { loader: async () => MicrosoftSignInPage },
    }),
  ],
});
